import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "reactions-modal-inner" }
const _hoisted_3 = { class: "reactions-modal-content" }
const _hoisted_4 = { class: "reactions-modal-top" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "reactions-modal-title" }
const _hoisted_7 = { class: "reactions-modal-list" }

import { AudioMessage, TextMessage } from "@/store/chats/types";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { computed } from "vue";
import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";
import { findUserById } from "@/utils/users";
import { Profile } from "@/store/auth/state";
import { ReactionsItem } from "@/types/chat";
import MessageReactionsModalItem from "../MessageReactionsModalItem/MessageReactionsModalItem.vue";

interface ChatMessageReactionsModalProps {
  message: TextMessage | AudioMessage;
  id: string;
}

interface Emits {
  (e: "closeReactionsModal"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessageReactionsModal',
  props: {
    message: {},
    id: {}
  },
  emits: ["closeReactionsModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);

const reactionsArray = computed(() => {
  const items = props.message.reactions?.items;
  if (!items) {
    return [];
  }
  return Object.entries(items)
    .map(([userId, emoji]) => {
      const numericalUserId = Number(userId);
      const isMine = numericalUserId === profile.value.id;
      const user = isMine ? profile.value : findUserById(Number(userId));
      if (!user) {
        return;
      }
      return {
        user: { id: numericalUserId, name: user.name, picture: user.picture },
        emoji,
        isMine: isMine,
      };
    })
    .filter(Boolean) as ReactionsItem[];
});

const closeModal = () => {
  emit("closeReactionsModal");
};

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "reactions-modal"
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("chat.chatContainer.messages.reactions.reactions")), 1),
          _createElementVNode("div", {
            class: "reactions-modal-close",
            onClick: closeModal
          }, [
            _createVNode(Icon, {
              icon: _unref(IconType).CROSS_GREY_CIRCLE
            }, null, 8, ["icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reactionsArray.value, (item) => {
            return (_openBlock(), _createBlock(MessageReactionsModalItem, _mergeProps({
              key: item.user.id
            }, item, {
              "message-id": _ctx.message.id,
              onCloseModal: closeModal
            }), null, 16, ["message-id"]))
          }), 128))
        ])
      ])
    ])), [
      [_directive_click_outside, closeModal]
    ])
  ], 8, _hoisted_1))
}
}

})